import { createI18n } from "vue-i18n/dist/vue-i18n.cjs";
import en from "./en.json";
import fr from "./fr.json";

export const i18n = createI18n({
  locale: "fr-FR",
  messages: {
    "en-US": en,
    "en-GB": en,
    "fr-FR": fr,
  },
  fallbackLocale: "fr-FR",
  legacy: false,
  globalInjection: true,
});
